import { apiSlice } from '../api/apiSlice';
import {
  CurrentResponse,
  GetQrCodeDataResponse,
  GetQrCodePrams,
  HistoryParams,
  HistoryResponse,
} from './esimApiSliceTypes';

const esimApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentEsims: builder.query<CurrentResponse, void>({
      query: () => ({
        url: '/esims/current',
        method: 'GET',
      }),
    }),

    getHistoryEsims: builder.query<HistoryResponse, HistoryParams>({
      query: (params) => {
        const { page = 1, limit = 10, ...queryParams } = params ?? {};
        return {
          url: '/esims/history',
          method: 'GET',
          params: {
            page,
            limit,
            ...queryParams,
          },
        };
      },
    }),

    getQRCode: builder.query<Blob, GetQrCodePrams>({
      query: (params) => {
        return {
          url: '/esims/qr-code',
          method: 'GET',
          params: { esimId: params.esimId },
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    getQRCodeData: builder.query<GetQrCodeDataResponse, GetQrCodePrams>({
      query: (params) => {
        return {
          url: '/esims/qr-code-data',
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage || 'en',
          },
          params: {
            esimId: params.esimId,
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCurrentEsimsQuery,
  useLazyGetCurrentEsimsQuery,
  useGetHistoryEsimsQuery,
  useLazyGetHistoryEsimsQuery,
  useGetQRCodeQuery,
  useLazyGetQRCodeQuery,
  useGetQRCodeDataQuery,
  useLazyGetQRCodeDataQuery,
} = esimApiSlice;
